import { AudioHTMLAttributes, DetailedHTMLProps, FC } from 'react'

interface Props extends DetailedHTMLProps<AudioHTMLAttributes<HTMLAudioElement>, HTMLAudioElement> {
	id?: string
}

const MDAudioPlayer: FC<Props> = ({ src, preload }: Props) => {
	return (
		<audio controls preload={preload}>
			<source src={src} type="audio/mpeg" />
		</audio>
	)
}

MDAudioPlayer.defaultProps = {
	preload: 'none',
}

export default MDAudioPlayer
